/**
 * SparkForm helper class. Used to set common properties on all forms.
 */
export default function (data) {
  const self = this;
  const initialData = data;

  _.extend(this, data);

  /**
   * Create the form error helper instance.
   */
  this.errors = new SparkFormErrors();

  this.busy = false;
  this.successful = false;

  /**
   * Start processing the form.
   */
  this.startProcessing = function () {
    self.errors.forget();
    self.busy = true;
    self.successful = false;
  };

  /**
   * Finish processing the form.
   */
  this.finishProcessing = function () {
    self.busy = false;
    self.successful = true;
  };

  /**
   * Reset the form to its original state.
   */
  this.reset = function () {
    _.extend(self, initialData);
    self.resetStatus();
  };

  /**
   * Reset the errors and other state for the form.
   */
  this.resetStatus = function () {
    self.errors.forget();
    self.busy = false;
    self.successful = false;
  };

  /**
   * Set the errors on the form.
   */
  this.setErrors = function (errors) {
    self.busy = false;
    self.errors.set(errors);
  };
}
